import React, { createContext, useContext, ReactNode, useMemo } from "react";
import { ModelReturnTypes } from "../hooks/useModel";
import useAIChatModel from "../models/aichat";

const GlobalModelsContext = createContext<ModelReturnTypes | undefined>(undefined);
interface GlobalModelProviderProps {
  children: ReactNode;
}
// register model as follow 3 step
export const modelHooks = {
  // step 1
  aichat: useAIChatModel,
};
export const GlobalModelProvider: React.FC<GlobalModelProviderProps> = ({ children }) => {
  // step 2
  const aichatModel = useAIChatModel();
  // step 3
  const modelInstances = useMemo(() => {
    return {
      aichat: aichatModel,
    };
  }, [aichatModel]);

  return (
    <GlobalModelsContext.Provider value={modelInstances}>{children}</GlobalModelsContext.Provider>
  );
};

export const useGlobalModelsContext = () => {
  const context = useContext(GlobalModelsContext);
  if (context === undefined) {
    throw new Error("useGlobalModelsContext must be used within a GlobalModelProvider");
  }
  return context;
};
